'use strict';

angular.module('mobile-apps')
	.service('TranslationImport', [
		'$modal',
		'$rootScope',
		'$timeout',
		'$q',
		'AvailableLanguages',
		'EntryMain',
		'EntryWarnings',
		'EventTracker',
		'Upload',
		'Utilities',
		'LanguageEntries',
		'SweetAlert',
		function(
			$modal,
			$rootScope,
			$timeout,
			$q,
			AvailableLanguages,
			EntryMain,
			EntryWarnings,
			EventTracker,
			Upload,
			Utilities,
			LanguageEntries,
			SweetAlert
		) {
			return function FileImport(mobileApp, group, language, tags, tagCategories) {

				this.mobileApp = mobileApp;
				this.group = group;
				this.language = language;
				this.tags = tags;
				this.tagCategories = tagCategories;

				this.availableLanguages = AvailableLanguages.get();

				this.fileFormats = [
					{
						id: 'android',
						name: 'Android XML',
						fileExtensions: [
							'xml'
						]
					},
					{
						id: 'angular_translate_json',
						name: 'Angular Translate JSON',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'chrome_i18n_json',
						name: 'Chrome i18n JSON',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'ember_i18n_json_module',
						name: 'Ember i18n JSON Module',
						fileExtensions: [
							'js'
						]
					},
					{
						id: 'gettext_po',
						name: 'Gettext PO File',
						fileExtensions: [
							'po'
						]
					},
					{
						id: 'gettext_pot',
						name: 'Gettext POT File',
						fileExtensions: [
							'pot'
						]
					},
					{
						id: 'go_i18n_json',
						name: 'go-i18n v1 JSON',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'i18next_json',
						name: 'i18next',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'java_properties',
						name: 'JAVA properties',
						fileExtensions: [
							'properties'
						]
					},
					{
						id: 'microsoft_resw',
						name: 'Microsoft Resource File',
						fileExtensions: [
							'resw'
						]
					},
					{
						id: 'microsoft_resx',
						name: 'Microsoft Resource File',
						fileExtensions: [
							'resx'
						]
					},
					{
						id: 'mozilla_i18n_json',
						name: 'Mozilla i18n JSON',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'mozilla_properties',
						name: 'Mozilla properties',
						fileExtensions: [
							'properties'
						]
					},
					{
						id: 'node_2_json',
						name: 'i18n-node-2',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'nested_json',
						name: 'Nested JSON',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'react_nested_json',
						name: 'React Nested JSON',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'react_simple_json',
						name: 'React Simple JSON',
						fileExtensions: [
							'json'
						]
					},
					{
						id: 'spreadsheet',
						name: 'Spreadsheet',
						fileExtensions: [
							'csv',
							'tsv',
							'xls',
							'xlsx'
						]
					},
					{
						id: 'strings',
						name: 'iOS strings',
						fileExtensions: [
							'strings'
						]
					},
					{
						id: 'stringsdict',
						name: 'iOS stringsdict',
						fileExtensions: [
							'stringsdict'
						]
					},
					{
						id: 'xliff',
						name: 'xliff',
						fileExtensions: [
							'xlf',
							'xliff'
						]
					},
					{
						id: 'ruby_on_rails_yaml',
						name: 'Ruby on Rails YAML',
						fileExtensions: [
							'yaml',
							'yml',
						]
					},
					{
						id: 'symfony_yaml',
						name: 'Symfony YAML',
						fileExtensions: [
							'yaml',
							'yml',
						]
					},
					{
						id: 'symfony2_yaml',
						name: 'Symfony 2 YAML',
						fileExtensions: [
							'yaml',
							'yml',
						]
					},
					{
						id: 'ini',
						name: 'Ini File',
						fileExtensions: [
							'ini'
						]
					},
					{
						id: 'arb',
						name: 'Flutter ARB File',
						fileExtensions: [
							'arb'
						]
					},
					{
						id: 'tmx',
						name: 'Translation Memory Exchange',
						fileExtensions: [
							'tmx'
						]
					},
					{
						id: 'tbx',
						name: 'Term Base Exchange',
						fileExtensions: [
							'tbx'
						]
					},
					{
						id: 'laravel_php',
						name: 'Laravel PHP File',
						fileExtensions: [
							'php'
						]
					}
				];

				/**
				 * Returns the file type of the given file
				 */
				this.getFileTypes = function(file) {
					var me = this;
					var fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();

					var returnTypes = [];
					me.fileFormats.forEach(function(fileFormat) {
						if (fileFormat.fileExtensions.indexOf(fileExtension) !== -1) {
							returnTypes.push(fileFormat);
						}
					});

					return returnTypes;
				};


				/**
				 * Takes the error from a server response and extracts the
				 * actual error to return. So that all errors are in the same
				 * format and can be displayed correctly to the user.
				 */
				this.rejectResponseError = function(errorResponse) {
					var errorMessage = errorResponse.statusText;
					if (errorResponse.data && errorResponse.data.message) {
						errorMessage = errorResponse.data.message;
					}
					return $q.reject(errorMessage);
				};


				/**
				 * Returns all the file-extensions we currently support
				 * importing from
				 */
				this.getSupportedFileExtensions = function() {
					var me = this;
					var i;
					var allowedExtensions = [];

					me.fileFormats.forEach(function (fileFormat) {
						for (i = 0;i < fileFormat.fileExtensions.length; i++) {
							if (allowedExtensions.indexOf(fileFormat.fileExtensions[i]) === -1) {
								allowedExtensions.push(fileFormat.fileExtensions[i]);
							}
						}

					});

					allowedExtensions.sort();

					return allowedExtensions;
				};


				/**
				 * Displays a modal which allows to select a file to import
				 */
				this.selectFile = function(entryKeys) {
					var me = this;

					var modalInstance = $modal.open({
						templateUrl: 'modules/mobile-apps/views/data-import-file-select-modal.client.view.html',
						controller: 'DataImportFileSelectModalController',
						size: 'lg'
					});

					return modalInstance.result.then(function (data) {
						var options = {};
						return me.importFileWithOptions(data.file, entryKeys, options);
					}, function(error) {
						if (error === 'cancel' || error === 'escape key press' || error === undefined) {
							// user did cancel
							return $q.when({});
						}

						return $q.reject(error);
					});
				};


				/**
				 * Imports the given file and lets the user select the import options
				 */
				this.importFileWithOptions = function (file, entryKeys, options) {
					var me = this;

					var fileTypes = me.getFileTypes(file);

					if (fileTypes.length === 0) {
						var allowedFileExtensions = me.getSupportedFileExtensions();
						var message = 'The given file is currently not supported. Please select one of the following one: ' + allowedFileExtensions.join(', ');
						Utilities.showMessage('Wrong file type!!', message, 'warning');
						return $q.reject(message);
					}

					return me.availableLanguages.$promise.then(
						function() {
							var modalInstance = $modal.open({
								templateUrl: 'modules/mobile-apps/views/data-import-modal.client.view.html',
								controller: 'DataImportModalController',
								size: 'md',
								resolve: {
									importInfo: function() {
										return {
											// TODO: Replace with variables
											mobileApp: me.mobileApp,
											fileTypes: fileTypes,
											options: options,
											groupsEnabled: me.mobileApp.groupsEnabled,
											group: me.group.name,
											language: me.availableLanguages[me.language.name],
											entries: entryKeys,
											tags: me.tags,
											tagCategories: me.tagCategories
										};
									}
								}
							});

							return modalInstance.result.then(function (data) {
								return me.importFile(file, data.fileType, data.entries, data.options);
							}, function(error) {
								if (error === 'cancel' || error === 'escape key press' || error === undefined) {
									// user did cancel
									return $q.when({});
								}

								return $q.reject(error);
							});
						}
					);
				};


				/**
				 * Applies the given tag changes
				*/
				this.assignTagsToEntries = function (keys, tags) {
					var tagsToAssign = {};
					
					tags.forEach(function(tag){
						tagsToAssign[tag._id] = 'add';
					});

					LanguageEntries.addRemoveTags({
						mobileAppId: this.mobileApp._id,
						tags:tagsToAssign,
						entries: keys
					}, function (response) {
						$rootScope.$broadcast('entriesChanged');
					}, function (errorResponse) {
						$timeout(function () {
							SweetAlert.swal(
								{
									title: 'Oops!',
									text: 'Sorry something went wrong',
									type: 'error',
									showCancelButton: false
								}
							);
						}, 50);
					});
				};


				/**
				 * Imports the given file
				 */
				this.importFile = function (file, fileType, entryKeys, options) {
					var me = this;

					var importPromise;
					if (fileType.indexOf('spreadsheet') !== -1) {
						// Spreadsheet needs special code because we have to
						// display a modal in which the user can select the columns
						importPromise = me.importFromFileSpreadsheet(file, entryKeys, options);
					} else {
						// All other files can simply be uploaded and so
						// imported directly
						importPromise = me.uploadFile(file, fileType, entryKeys, options);
					}

					Utilities.loadingUiModal('open');
					return importPromise.then(
					  function(data) {
						  if(options.applyTags.selectedTags.length){
							me.assignTagsToEntries(data.keys, options.applyTags.selectedTags);
						  }
						  Utilities.loadingUiModal('close');
						  var dataSend = {
							  entries: entryKeys,
							  options: options
						  };
						  return me.showImportSuccessMessage(data, dataSend, file);
					  }
					).catch(function(error) {
						if (error === undefined) {
							// user did cancel
							return $q.when({});
						}

						Utilities.loadingUiModal('close');
						return $q.reject(error);
					});
				};


				/**
				 * Displays a modal to user to choose which column represents
				 * which data and then imports the given file
				 */
				this.importFromFileSpreadsheet = function (file, entryKeys, options) {
					var me = this;

					var fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);

					if (['csv', 'tsv', 'xls', 'xlsx'].indexOf(fileExtension) === -1) {
						var message = 'Wrong file-type selected. Please select a ".csv/.tsv/.xls/.xlsx" file!';
						Utilities.showMessage('Wrong file type!!', message, 'warning');
						return $q.reject(message);
					}

					var groupId;
					if (me.group && me.group._id) {
						groupId = me.group._id;
					}

					Utilities.loadingUiModal('open');
					return me.uploadFile(file, 'spreadsheet', entryKeys, options).then(
						function(result) {
							Utilities.loadingUiModal('close');

							var modalInstance = $modal.open({
								templateUrl: 'modules/mobile-apps/views/data-import-spreadsheet-modal.client.view.html',
								controller: 'DataImportSpreadsheetModalController',
								size: 'lg',
								resolve: {
									ImportInfo: function() {
										return {
											mobileApp: me.mobileApp,
											fileContent: result.content,
											file: result.file,
											options: options,
											entries: entryKeys,
											groupId: groupId
										};
									}
								}
							});

							return modalInstance.result;
						}
					);
				};



				/**
				 * Returns the warning messages for the given entries and check
				 * functions
				 */
				this.getEntryWarnings = function(entries, issueCheckFunctions) {
					var me = this;

					// Go through all the entries and check if any warnings fire
					var entry, i, returnData = {};
					for (var fieldName in issueCheckFunctions) {

						var warningFields = Object.keys(issueCheckFunctions[fieldName]);

						for (i=0;i<entries.length;i++) {
							entry = entries[i];
							// Data for the check-functions
							var data = {
								base: {
									value: entry.baseValue,
									valueUpdatedAt: entry.baseValueUpdatedAt
								},
								languages: {
									base: me.mobileApp.baseLanguage,
									entry: me.language.name
								},
								entry: entry,
								isMasterLang: me.language.name === me.mobileApp.baseLanguage
							};
							var warnings = EntryWarnings.runCheckFunctions(warningFields, data, issueCheckFunctions[fieldName]);

							if (warnings.length !== 0) {
								// If there are warnings save them
								if (!returnData.hasOwnProperty(entry.key)) {
									returnData[entry.key] = {};
								}

								returnData[entry.key][fieldName] = warnings;
							}
						}
					}

					return returnData;
				};



				/**
				 * Returns only the new warnings which are in the after data but
				 * has not been in the before one
				 */
				this.getNewWarnings = function(warningsBefore, warningsAfter) {

					var newWarnings = {};

					for (var key in warningsAfter) {
						if (!warningsBefore.hasOwnProperty(key)) {
							// There were no warnings for the key before so they are
							// all new
							newWarnings[key] = warningsAfter[key];
						} else {
							// There were warnings before so check each warning-category

							var warningCategories = Object.keys(warningsAfter[key]);
							for (var i=0;i<warningCategories;i++) {
								var warningCategory = warningCategories[i];
								if (!warningsBefore[key].hasOwnProperty(warningCategory)) {
									// There were no warnings of that category before
									// so add them ad new
									if (!newWarnings.hasOwnProperty(key)) {
										newWarnings[key] = {};
									}
									newWarnings[key][warningCategory] = warningsAfter[key][warningCategory];
								}
							}
						}
					}
					return newWarnings;
				};


				/**
				 * Refreshes the entries
				 */
				this.refreshEntries = function() {
					// TODO: Maybe later convert properly into promise
					var me = this;
					EntryMain.refreshEntries();

					return $q(function(resolve, reject) {
						EntryMain.loadEntries(me.mobileApp._id, me.group._id, [me.language._id], false, function(err, result) {
							if (err) {
								return reject(err);
							}

							return resolve(result);
						});
					});
				};


				/**
				 * Displays a message to inform the user about what got updated
				 * and if there were any issues
				 */
				this.showImportSuccessMessage = function (data, dataSend, file) {
					var me = this;

					// Track the import event
					var trackData = {
						entries_total: data.total,
						entries_added: data.added,
						entries_updated: data.updated,
						file_name: file.name
					};

					// Save the options as separate entries that we can use them correctly
					for (var optionKey in dataSend.options) {
						trackData['options_' + optionKey] = dataSend.options[optionKey];
					}

					if (!dataSend.entries || dataSend.entries.length === 0) {
						// Full data import
						EventTracker.track('Import Success', 'Data Import', trackData);
					} else {
						// Selected data import
						EventTracker.track('Import Selected Success', 'Data Import', trackData);
					}

					// Define the checks which we want to check for after the import
					var issueCheckFunctions = {
						hasIssuesVariableMissing: {
							draft: [
								EntryWarnings.checkFunctions.variableMissingCheckFunction
							],
							target: [
								EntryWarnings.checkFunctions.variableMissingCheckFunction
							]
						},
						hasIssuesToLong: {
							draft: [
								EntryWarnings.checkFunctions.maxLengthCheckFunction
							],
							target: [
								EntryWarnings.checkFunctions.maxLengthCheckFunction
							]
						},
						hasIssuesGlossaryTermMissing: {
							draft: [
								EntryWarnings.checkFunctions.glossaryCheckFunction
							],
							target: [
								EntryWarnings.checkFunctions.glossaryCheckFunction
							]
						}
					};

					// Get the full data of the entries which got imported
					var entries = [];
					data.keys.forEach(function(key) {
						if (EntryMain.allValues.hasOwnProperty(key)) {
							entries.push(EntryMain.allValues[key]);
						}
					});

					// Get all the warnings which have been there before the import
					// (The new data did not get loaded so we still get the old data
					// returned till we refresh)
					var warningsBefore = me.getEntryWarnings(entries, issueCheckFunctions);

					// Refresh the entries to get the newly imported data
					return me.refreshEntries().then(
						function(result) {
							// Create a new array with the data because entries which
							// got added will not be in the one that got created before
							// the refresh
							entries.length = 0;
							data.keys.forEach(function(key) {
								if (EntryMain.allValues.hasOwnProperty(key)) {
									entries.push(EntryMain.allValues[key]);
								}
							});

							// Get the warnings of the imported entries now that the new
							// data got loaded
							var warningsAfter = me.getEntryWarnings(entries, issueCheckFunctions);

							// Get only the warnings which appeared since as result of the import
							var newWarnings = me.getNewWarnings(warningsBefore, warningsAfter);

							// Build the success message to display to the user
							var message = file.name + ' uploaded successfully.\<br\> Entries in file : ' + data.total + '\<br\> added : ' + data.added + '\<br\> updated : ' + data.updated;
							if (me.mobileApp.groupsEnabled) {
								message += '\<br\> changed from other group : ' + data.groupChanged;
							}
							var warnings = [];
							if (Object.keys(newWarnings).length !== 0) {
								message += '<br /><br /><strong>The new/updated translations have now this additional warnings:</strong><div class="duplicate-entries"><ul>';
								for (var key in newWarnings) {
									warnings.length = 0;

									for (var warningCategory in newWarnings[key]) {
										warnings.push.apply(warnings,newWarnings[key][warningCategory]);
									}

									message += '<li><strong>' + key + '</strong><br />' + warnings.join(', ') + '</li>';
								}
								message += '</ul></div>';
							}

							return Utilities.showMessage('Success', message, 'success')
								.then(
									function() {
										return $q.when(data);
									}
								);
						}
					);

				};


				/**
				 * Uploads file to server and imports the data
				 */
				this.uploadFile = function (file, fileType, entryKeys, options) {
					var me = this;

					var groupId;
					if (me.group && me.group._id) {
						groupId = me.group._id;
					}

					var sendData = {
						fileType: fileType,
						entries: entryKeys,
						options: options,
						groupId: groupId
					};

					// Check if file is supported and get the correct upload url
					var uploadUrl;
					if (!fileType) {
						return $q.reject('Import of file not supported');
					} else if (fileType === 'xliff') {
						uploadUrl = '/v1/projects/' + me.mobileApp._id + '/languages/' + me.language._id + '/groups/' + groupId + '/import';
					} else if (fileType === 'spreadsheet') {
						console.log('k1');

						uploadUrl = '/v1/projects/' + me.mobileApp._id + '/upload-spreadsheet';
					} else {
						sendData.importLanguage = this.language.name;
						uploadUrl = '/v1/projects/' + me.mobileApp._id + '/import-file';
					}

					return Upload.upload({
						url: uploadUrl,
						file: file,
						data: sendData
					})
					.then(
						function(data) {
							return $q.when(data.data);
						}
					).catch(function(error) {
						return me.rejectResponseError(error);
					});
				};

			};
    }
]);
